module.exports = __webpack_public_path__ + "static/media/default_profile.cd6d11ef.png";